import * as React from "react";
import "./Graph.css";
import PieChart from "./PieChart";

const createChartData = arr => {
  return arr.map((w, i) => {
    return {
      label: "Tribe " + (i + 1),
      value: w
    };
  });
};
export default class extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.weightings) return null;
    return <PieChart data={createChartData(this.props.weightings)} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Graph.js